import React from 'react';
import NukaCarousel from 'nuka-carousel';
import Sorority from '../images/redesign-images/home-new/sorority-mobile.jpg';
import Fraternity from '../images/redesign-images/home-new/fraternity-mobile.jpg';
import HigherEd from '../images/redesign-images/home-new/higher-ed-mobile.jpg';
import Clubs from '../images/redesign-images/home-new/collegiate-mobile.jpg';
import LinkArrowDark from '../images/redesign-images/icons/link-arrow-dark.svg';

const SingleCarousel = () => {
  let nukaCarouselProps = {
    slidesToShow: 1,
    autoplay: true,
    wrapAround: true,
    withoutControls: true,
    autoplayInterval: 6000,
    speed: 400,
    easing: 'easeQuadInOut',
    cellSpacing: 8,
    cellAlign: 'center',
    slideWidth: 0.8,
  };

  return (
    <NukaCarousel {...nukaCarouselProps}>
      <a href="/sorority" className="block home-hero-carousel__item">
        <div className="home-hero-carousel__item-content">
          <h3 className="heading-base c-heading-cofo-lg uppercase man white shadow">
            Sorority
          </h3>
          <div>
            <div className="link-tile-grid__item-icon link-tile-grid__item-icon--alt">
              <span className="link-tile-grid__item-icon-text">Learn More</span>
              <img src={LinkArrowDark} alt="" width="9" height="15" />
            </div>
          </div>
        </div>
        <img
          src={Sorority}
          alt=""
          width="2040"
          height="1350"
          className="u-border-radius-xs"
        />
      </a>
      <a href="/fraternity" className="block home-hero-carousel__item">
        <div className="home-hero-carousel__item-content">
          <h3 className="heading-base c-heading-cofo-lg uppercase man white shadow">
            Fraternity
          </h3>
          <div>
            <div className="link-tile-grid__item-icon link-tile-grid__item-icon--alt">
              <span className="link-tile-grid__item-icon-text">Learn More</span>
              <img src={LinkArrowDark} alt="" width="9" height="15" />
            </div>
          </div>
        </div>
        <img
          src={Fraternity}
          alt=""
          width="2040"
          height="1350"
          className="u-border-radius-xs"
        />
      </a>
      <a href="/higher-ed" className="block home-hero-carousel__item">
        <div className="home-hero-carousel__item-content">
          <h3 className="heading-base c-heading-cofo-lg uppercase man white shadow">
            Higher Education
          </h3>
          <div>
            <div className="link-tile-grid__item-icon link-tile-grid__item-icon--alt">
              <span className="link-tile-grid__item-icon-text">Learn More</span>
              <img src={LinkArrowDark} alt="" width="9" height="15" />
            </div>
          </div>
        </div>
        <img
          src={HigherEd}
          alt=""
          width="2040"
          height="1350"
          className="u-border-radius-xs"
        />
      </a>
      <a href="/collegiate" className="block home-hero-carousel__item">
        <div className="home-hero-carousel__item-content">
          <h3 className="heading-base c-heading-cofo-lg uppercase man white shadow">
            Clubs & Organizations
          </h3>
          <div>
            <div className="link-tile-grid__item-icon link-tile-grid__item-icon--alt">
              <span className="link-tile-grid__item-icon-text">Learn More</span>
              <img src={LinkArrowDark} alt="" width="9" height="15" />
            </div>
          </div>
        </div>
        <img
          src={Clubs}
          alt=""
          width="2040"
          height="1350"
          className="u-border-radius-xs"
        />
      </a>
    </NukaCarousel>
  );
};

export default SingleCarousel;
